// extracted by mini-css-extract-plugin
export var ignore = "_6m-1";
export var mapping = "_6m-0";
export var range = "_6m-4";
export var savings = "_6m-3";
export var settings = "_6m-2";